(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[795],{

/***/ 6721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Heading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4924);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6010);
/* harmony import */ var _heading_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1435);
/* harmony import */ var _heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_heading_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var Heading = function(param) {
    var _as = param.as, as = _as === void 0 ? "h2" : _as, _centered = param.centered, centered = _centered === void 0 ? false : _centered, _size = param.size, size = _size === void 0 ? "sm" : _size, _id = param.id, id = _id === void 0 ? "" : _id, className = param.className, children = param.children;
    var Comp = as;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default().heading), (_heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, (_heading_module_scss__WEBPACK_IMPORTED_MODULE_2___default().centered), centered), className),
        id: id,
        children: children
    });
};


/***/ }),

/***/ 5566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Meta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(387);
/* harmony import */ var next_dist_client_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_client_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7469);





var Meta = function(props) {
    var ref, ref1;
    var router = (0,next_dist_client_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var resolvedMetadata = react__WEBPACK_IMPORTED_MODULE_3__.useMemo(function() {
        var _title, _description, _cannonical, _ogImage, _title1;
        var data = {
            title: (_title = props.title) !== null && _title !== void 0 ? _title : _lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMeta.title */ .sO.title,
            description: (_description = props.description) !== null && _description !== void 0 ? _description : _lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMeta.description */ .sO.description,
            canonical: (_cannonical = props.cannonical) !== null && _cannonical !== void 0 ? _cannonical : "".concat(_lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .siteOrigin */ .i0).concat(router.pathname),
            ogImage: {
                url: (_ogImage = props.ogImage) !== null && _ogImage !== void 0 ? _ogImage : _lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMeta.ogImage */ .sO.ogImage,
                alt: (_title1 = props.title) !== null && _title1 !== void 0 ? _title1 : _lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMeta.title */ .sO.title,
                width: 1200,
                height: 630
            },
            twitter: {
                cardType: "summary_large_image",
                handle: _lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMeta.twitter.handle */ .sO.twitter.handle,
                site: _lib_constants__WEBPACK_IMPORTED_MODULE_4__/* .defaultMeta.twitter.site */ .sO.twitter.site
            },
            noIndex: props.noIndex,
            noFollow: props.noFollow
        };
        if (!data.ogImage.url.startsWith("http")) {
            throw new Error("ogImage must be an absolute URL.");
        }
        if (!data.canonical.startsWith("http")) {
            throw new Error("canonical must be an absolute URL.");
        }
        return data;
    }, [
        props,
        router.pathname
    ]);
    var _themeColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    charSet: "utf-8"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "viewport",
                    content: "width=device-width, height=device-height, initial-scale=1, shrink-to-fit=no"
                }, "viewport"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "theme-color",
                    content: (_themeColor = props.themeColor) !== null && _themeColor !== void 0 ? _themeColor : "#000000"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "apple-touch-icon",
                    sizes: "180x180",
                    href: "/apple-touch-icon.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "icon",
                    type: "image/png",
                    sizes: "32x32",
                    href: "/favicon-32x32.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "icon",
                    type: "image/png",
                    sizes: "16x16",
                    href: "/favicon-16x16.png"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "manifest",
                    href: "/site.webmanifest"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "mask-icon",
                    href: "/safari-pinned-tab.svg",
                    color: "#5bbad5"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "msapplication-TileColor",
                    content: "#da532c"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "theme-color",
                    content: "#ffffff"
                }),
                props.noIndex && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "noindex"
                }),
                props.noFollow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "robots",
                    content: "nofollow"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: resolvedMetadata.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: resolvedMetadata.description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: resolvedMetadata.twitter.cardType
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:site",
                    content: resolvedMetadata.twitter.site
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:creator",
                    content: resolvedMetadata.twitter.site
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:title",
                    content: resolvedMetadata.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:description",
                    content: resolvedMetadata.description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:image",
                    content: resolvedMetadata.ogImage.url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: resolvedMetadata.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: resolvedMetadata.description
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: resolvedMetadata.canonical
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image",
                    content: resolvedMetadata.ogImage.url
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image:alt",
                    content: resolvedMetadata.ogImage.alt
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image:width",
                    content: resolvedMetadata.ogImage.width + ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:image:height",
                    content: resolvedMetadata.ogImage.height + ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: resolvedMetadata.canonical
                }),
                (ref = props.preload) === null || ref === void 0 ? void 0 : ref.map(function(param) {
                    var href = param.href, as = param.as;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "preload",
                        href: href,
                        as: as
                    }, href);
                }),
                (ref1 = props.prefetch) === null || ref1 === void 0 ? void 0 : ref1.map(function(param) {
                    var href = param.href, as = param.as;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "prefetch",
                        href: href,
                        as: as
                    }, href);
                })
            ]
        })
    });
};


/***/ }),

/***/ 504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "TY": function() { return /* binding */ Timeline; },
/* harmony export */   "ko": function() { return /* binding */ ProgressBar; },
/* harmony export */   "rq": function() { return /* binding */ ProgressMarker; }
/* harmony export */ });
/* unused harmony exports ANIMATION_UPDATE_INTERVAL_MS, ANIMATION_UPDATE_INTERVAL_SEC */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6010);
/* harmony import */ var lib_gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8997);
/* harmony import */ var lodash_clamp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4691);
/* harmony import */ var lodash_clamp__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_clamp__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _hooks_use_gsap_time__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3311);
/* harmony import */ var _hooks_use_viewport_size__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8860);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7469);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21);
/* harmony import */ var _progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5644);
/* harmony import */ var _progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11__);














var ANIMATION_UPDATE_INTERVAL_MS = 1000;
var ANIMATION_UPDATE_INTERVAL_SEC = (0,_lib_utils__WEBPACK_IMPORTED_MODULE_7__/* .msToSecs */ .Fg)(ANIMATION_UPDATE_INTERVAL_MS);
var getElmCoordById = function(id, axes) {
    if (!_lib_constants__WEBPACK_IMPORTED_MODULE_6__/* .isClient */ .C5) return 0;
    var elm = document.getElementById(id);
    if (!elm) {
        throw new Error("Element with id ".concat(id, " not found"));
    }
    var bounds = elm.getBoundingClientRect();
    return bounds[axes === "x" ? "left" : "top"];
};
var ProgressBar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(param, ref) {
    var _solid = param.solid, solid = _solid === void 0 ? false : _solid, primaryColor = param.primaryColor, secondaryColor = param.secondaryColor, progress = param.progress, markers = param.markers, markerSize = param.markerSize, _markerVisible = param.markerVisible, markerVisible = _markerVisible === void 0 ? true : _markerVisible, markerActiveColor = param.markerActiveColor, onMarkerUpdate = param.onMarkerUpdate, _direction = param.direction, direction = _direction === void 0 ? "horizontal" : _direction, _animated = param.animated, animated = _animated === void 0 ? true : _animated;
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(undefined), lastActiveMarker = _$ref[0], setLastActiveMarker = _$ref[1];
    var barRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var progressRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var prevProgress = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(progress || 0);
    var timeline = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(animated ? lib_gsap__WEBPACK_IMPORTED_MODULE_1__/* .gsap.timeline */ .p8.timeline({
        autoRemoveChildren: true
    }) : lib_gsap__WEBPACK_IMPORTED_MODULE_1__/* .gsap */ .p8);
    var orderedMarkers = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)([]);
    var width = (0,_hooks_use_viewport_size__WEBPACK_IMPORTED_MODULE_5__/* .useViewportSize */ .n)().width;
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]), internalMarkers = _$ref1[0], setInternalMarkers = _$ref1[1];
    var update = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(progress) {
        var _$ref;
        var duration = ANIMATION_UPDATE_INTERVAL_SEC;
        var gsapFunc = progress < prevProgress.current || !animated ? "set" : "to";
        if ((_$ref = orderedMarkers.current) === null || _$ref === void 0 ? void 0 : _$ref.some(function(param) {
            var position = param.position;
            return position <= progress;
        })) {
            var firstCoincidence = orderedMarkers.current.find(function(param) {
                var position = param.position;
                return position <= progress;
            });
            if (firstCoincidence) {
                setLastActiveMarker(function(prevValue) {
                    if ((prevValue === null || prevValue === void 0 ? void 0 : prevValue.position) !== (firstCoincidence === null || firstCoincidence === void 0 ? void 0 : firstCoincidence.position)) {
                        var _$ref, _$ref1, _$ref2;
                        onMarkerUpdate === null || onMarkerUpdate === void 0 ? void 0 : onMarkerUpdate(firstCoincidence, ((_$ref = orderedMarkers.current) === null || _$ref === void 0 ? void 0 : _$ref.filter(function(param) {
                            var position = param.position;
                            return position <= progress;
                        })) || []);
                        prevValue === null || prevValue === void 0 ? void 0 : (_$ref1 = prevValue.onInactive) === null || _$ref1 === void 0 ? void 0 : _$ref1.call(prevValue);
                        (_$ref2 = firstCoincidence.onActive) === null || _$ref2 === void 0 ? void 0 : _$ref2.call(firstCoincidence);
                    }
                    return firstCoincidence;
                });
            }
        } else {
            setLastActiveMarker(function(prevValue) {
                var _$ref;
                prevValue === null || prevValue === void 0 ? void 0 : (_$ref = prevValue.onInactive) === null || _$ref === void 0 ? void 0 : _$ref.call(prevValue);
                return undefined;
            });
        }
        if (direction === "horizontal") {
            if (progressRef.current) {
                timeline.current[gsapFunc](progressRef.current, {
                    "--left": "".concat(progress, "%"),
                    ease: "linear",
                    duration: duration
                });
            }
        } else {
            if (progressRef.current) {
                timeline.current[gsapFunc](progressRef.current, {
                    "--top": "".concat(progress, "%"),
                    ease: "linear",
                    duration: duration
                });
            }
        }
        prevProgress.current = progress;
    }, [
        direction,
        onMarkerUpdate,
        animated
    ]);
    var getPercentageById = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(id) {
        var _$ref;
        if (!barRef.current) return;
        var _$ref1 = (_$ref = barRef.current) === null || _$ref === void 0 ? void 0 : _$ref.getBoundingClientRect(), left = _$ref1.left, top = _$ref1.top, height = _$ref1.height, width = _$ref1.width;
        var barCoord = direction === "horizontal" ? left : top;
        var barSize = direction === "horizontal" ? width : height;
        var markerElmCoord = getElmCoordById(id, direction === "horizontal" ? "x" : "y");
        return lodash_clamp__WEBPACK_IMPORTED_MODULE_2___default()(markerElmCoord - barCoord, 0, barSize) / barSize * 100;
    }, [
        direction
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useImperativeHandle)(ref, function() {
        return {
            update: update,
            getPercentageById: getPercentageById,
            elm: barRef.current
        };
    }, [
        update,
        getPercentageById
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!barRef.current) return;
        var _$ref = barRef.current.getBoundingClientRect(), left = _$ref.left, width = _$ref.width, top = _$ref.top, height = _$ref.height;
        var newMarkers = markers === null || markers === void 0 ? void 0 : markers.map(function(marker) {
            var position;
            if (typeof marker.position === "string") {
                var barCoord = direction === "horizontal" ? left : top;
                var barSize = direction === "horizontal" ? width : height;
                var markerElmCoord = getElmCoordById(marker.position, direction === "horizontal" ? "x" : "y");
                position = lodash_clamp__WEBPACK_IMPORTED_MODULE_2___default()(markerElmCoord - barCoord, 0, barSize) / barSize * 100;
            } else {
                position = marker.position;
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, marker), {
                normalizedPosition: position / 100,
                position: position
            });
        });
        setInternalMarkers(newMarkers || []);
    }, [
        markers,
        direction,
        width
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        orderedMarkers.current = internalMarkers === null || internalMarkers === void 0 ? void 0 : internalMarkers.sort(function(a, b) {
            return b.position - a.position;
        });
    }, [
        internalMarkers
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (progress != undefined) {
            update(progress);
        }
    }, [
        update,
        progress
    ]);
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            // @ts-ignore
            "--color-primary": primaryColor,
            "--color-secondary": secondaryColor
        },
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["progress-bar"]), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, (_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default().vertical), direction === "vertical"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, (_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default().horizontal), direction === "horizontal"), _obj)),
        ref: barRef,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default().progress),
                ref: progressRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["progress-gradient"]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default().solid), solid))
                })
            }),
            markerVisible && (internalMarkers === null || internalMarkers === void 0 ? void 0 : internalMarkers.map(function(param, idx) {
                var position = param.position, normalizedPosition = param.normalizedPosition, activeColor = param.activeColor;
                var isOnEnds = position === 0 || position === 100;
                var _obj;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProgressMarker, {
                    size: markerSize,
                    color: primaryColor,
                    activeColor: activeColor || markerActiveColor,
                    active: lastActiveMarker !== undefined && position <= lastActiveMarker.position,
                    style: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, "--".concat(direction === "horizontal" ? "left" : "top"), position + "%"), //@ts-ignore
                    (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, "--translate-y", direction === "vertical" && isOnEnds ? normalizedPosition : "0.5"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, "--translate-x", direction === "horizontal" && isOnEnds ? normalizedPosition : "0.5"), _obj),
                    className: (_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default().marker)
                }, "".concat(position, "-").concat(idx));
            }))
        ]
    });
});
var ProgressMarker = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? 18 : _size, _active = _param.active, active = _active === void 0 ? false : _active, className = _param.className, style = _param.style, color = _param.color, activeColor = _param.activeColor, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "size",
        "active",
        "className",
        "style",
        "color",
        "activeColor"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        // @ts-ignore
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            "--color": active ? activeColor || color : color
        }, style),
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default().marker), (_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default().animated), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, (_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default().active), active), className)
    }, props), {
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_progress_bar_module_scss__WEBPACK_IMPORTED_MODULE_11___default()["marker-thumb"]),
            /* @ts-ignore */ style: {
                "--size": size + "px"
            }
        })
    }));
});
var Timeline = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(_param, ref) {
    var _playing = _param.playing, playing = _playing === void 0 ? false : _playing, duration = _param.duration, onStart = _param.onStart, onComplete = _param.onComplete, _loop = _param.loop, loop = _loop === void 0 ? true : _loop, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "playing",
        "duration",
        "onStart",
        "onComplete",
        "loop"
    ]);
    var progressRef = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var handleUpdate = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function(progress) {
        var _$ref;
        (_$ref = progressRef.current) === null || _$ref === void 0 ? void 0 : _$ref.update(progress.percentage);
    }, []);
    var time = (0,_hooks_use_gsap_time__WEBPACK_IMPORTED_MODULE_4__/* .useGsapTime */ .r)({
        duration: duration,
        onUpdate: handleUpdate,
        onStart: onStart,
        onComplete: onComplete,
        loop: loop
    });
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useImperativeHandle)(ref, function() {
        return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, time), {
            seek: function(progressOrId) {
                var progress;
                if (typeof progressOrId === "string") {
                    if (!progressRef.current) return;
                    var elmProgress = progressRef.current.getPercentageById(progressOrId);
                    if (elmProgress === undefined) return;
                    progress = elmProgress;
                } else {
                    progress = progressOrId;
                }
                time.seek(progress);
            }
        });
    }, [
        time
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (playing === true) {
            time.start();
        } else if (playing === false) {
            time.pause();
        }
        return time.pause;
    }, [
        time,
        playing
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProgressBar, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        animated: false
    }, rest), {
        ref: progressRef
    }));
});


/***/ }),

/***/ 8903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Section; },
/* harmony export */   "O": function() { return /* binding */ SectionHeading; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_common_heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6721);
/* harmony import */ var _section_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2676);
/* harmony import */ var _section_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_section_module_scss__WEBPACK_IMPORTED_MODULE_7__);









var Section = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var className = _param.className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_section_module_scss__WEBPACK_IMPORTED_MODULE_7___default().section), className)
    }, props), {
        ref: ref
    }));
});
function sluggify(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, "-");
}
var SectionHeading = function(param) {
    var centered = param.centered, title = param.title, subtitle = param.subtitle;
    var DescriptionElm = typeof subtitle === "string" ? "p" : "div";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_section_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["section-heading"]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_heading__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X, {
                id: sluggify(title),
                centered: centered,
                children: title
            }),
            subtitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DescriptionElm, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((_section_module_scss__WEBPACK_IMPORTED_MODULE_7___default().subtitle), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, (_section_module_scss__WEBPACK_IMPORTED_MODULE_7___default().centered), centered)),
                children: subtitle
            })
        ]
    });
};


/***/ }),

/***/ 5413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);






var Container = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var className = _param.className, _size = _param.size, size = _size === void 0 ? "md" : _size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "className",
        "size"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("container", size, className),
        ref: ref
    }));
});


/***/ }),

/***/ 5315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ PageLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/lib/gsap/index.ts
var gsap = __webpack_require__(8997);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/primitives/link/index.tsx
var primitives_link = __webpack_require__(3761);
// EXTERNAL MODULE: ./src/components/layout/container/index.tsx
var container = __webpack_require__(5413);
// EXTERNAL MODULE: ./src/components/layout/announcement-bar/announcement-bar.module.scss
var announcement_bar_module = __webpack_require__(199);
var announcement_bar_module_default = /*#__PURE__*/__webpack_require__.n(announcement_bar_module);
;// CONCATENATED MODULE: ./src/components/layout/announcement-bar/index.tsx



var AnnouncementBar = function(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (announcement_bar_module_default()).announcement,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* Container */.W, {
            size: "md",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (announcement_bar_module_default()).text,
                children: text
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/future/image.js
var future_image = __webpack_require__(1608);
var image_default = /*#__PURE__*/__webpack_require__.n(future_image);
// EXTERNAL MODULE: ./src/components/common/heading/index.tsx
var heading = __webpack_require__(6721);
// EXTERNAL MODULE: ./src/components/common/progress-bar/index.tsx
var progress_bar = __webpack_require__(504);
;// CONCATENATED MODULE: ./src/components/icons/social.tsx

var Discord = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2144_5001)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M24.3045 8.46995C22.7705 7.76607 21.1255 7.24748 19.4055 6.95046C19.3742 6.94473 19.3429 6.95906 19.3268 6.98771C19.1152 7.36399 18.8809 7.85488 18.7168 8.24072C16.8668 7.96377 15.0264 7.96377 13.2144 8.24072C13.0502 7.84631 12.8074 7.36399 12.5949 6.98771C12.5787 6.96001 12.5474 6.94569 12.5161 6.95046C10.7971 7.24653 9.15207 7.76512 7.61709 8.46995C7.6038 8.47568 7.59241 8.48524 7.58485 8.49764C4.4646 13.1592 3.60983 17.7062 4.02915 22.1969C4.03105 22.2189 4.04338 22.2399 4.06046 22.2532C6.11911 23.7651 8.11327 24.6829 10.0704 25.2912C10.1017 25.3008 10.1349 25.2893 10.1548 25.2635C10.6178 24.6313 11.0305 23.9647 11.3843 23.2637C11.4052 23.2226 11.3853 23.1739 11.3426 23.1577C10.688 22.9093 10.0647 22.6066 9.46513 22.2628C9.4177 22.2351 9.41391 22.1673 9.45754 22.1348C9.58371 22.0402 9.70991 21.9419 9.83039 21.8425C9.85219 21.8244 9.88256 21.8206 9.90819 21.832C13.8471 23.6304 18.1115 23.6304 22.0039 21.832C22.0296 21.8196 22.0599 21.8235 22.0827 21.8416C22.2032 21.9409 22.3294 22.0402 22.4565 22.1348C22.5001 22.1673 22.4973 22.2351 22.4498 22.2628C21.8503 22.6133 21.227 22.9093 20.5714 23.1567C20.5288 23.1729 20.5098 23.2226 20.5307 23.2637C20.8921 23.9637 21.3048 24.6303 21.7592 25.2626C21.7782 25.2893 21.8123 25.3008 21.8436 25.2912C23.8103 24.6829 25.8044 23.7651 27.863 22.2532C27.8811 22.2399 27.8925 22.2198 27.8944 22.1978C28.3962 17.0062 27.0538 12.4964 24.3358 8.49859C24.3292 8.48524 24.3178 8.47568 24.3045 8.46995ZM11.9725 19.4626C10.7866 19.4626 9.80951 18.3738 9.80951 17.0367C9.80951 15.6997 10.7677 14.6109 11.9725 14.6109C13.1868 14.6109 14.1545 15.7092 14.1355 17.0367C14.1355 18.3738 13.1773 19.4626 11.9725 19.4626ZM19.97 19.4626C18.7841 19.4626 17.807 18.3738 17.807 17.0367C17.807 15.6997 18.7651 14.6109 19.97 14.6109C21.1843 14.6109 22.1519 15.7092 22.133 17.0367C22.133 18.3738 21.1843 19.4626 19.97 19.4626Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2144_5001",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "19.5938",
                        fill: "white",
                        transform: "translate(4 6)"
                    })
                })
            })
        ]
    });
};
var Twitter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                clipPath: "url(#clip0_2144_5004)",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M28 8.3831C27.117 8.77471 26.168 9.03939 25.172 9.15843C26.1886 8.54901 26.9693 7.58406 27.3369 6.43432C26.3856 6.99853 25.3318 7.40831 24.2102 7.62918C23.312 6.67222 22.0323 6.07422 20.6162 6.07422C17.8968 6.07422 15.6921 8.27881 15.6921 10.998C15.6921 11.3839 15.7358 11.7597 15.8197 12.1201C11.7274 11.9148 8.09929 9.95448 5.67076 6.97552C5.24692 7.70275 5.0041 8.54858 5.0041 9.45094C5.0041 11.1592 5.87346 12.6663 7.19464 13.5493C6.38745 13.5237 5.62827 13.3022 4.96434 12.9334C4.96399 12.954 4.96399 12.9746 4.96399 12.9953C4.96399 15.381 6.66125 17.3711 8.91377 17.8234C8.50056 17.936 8.06558 17.9961 7.61646 17.9961C7.2992 17.9961 6.99072 17.9653 6.69014 17.9078C7.31667 19.864 9.13508 21.2876 11.2897 21.3273C9.60456 22.6479 7.48144 23.4351 5.17459 23.4351C4.77718 23.4351 4.38521 23.4118 4 23.3664C6.17904 24.7634 8.76726 25.5785 11.5479 25.5785C20.6047 25.5785 25.5572 18.0756 25.5572 11.569C25.5572 11.3555 25.5525 11.1431 25.543 10.932C26.505 10.2378 27.3398 9.37052 28 8.3831Z"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2144_5004",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "24",
                        height: "19.5938",
                        transform: "translate(4 6)"
                    })
                })
            })
        ]
    });
};
var Linkedin = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.00703 4H27.993C27.9969 4 28 4.00315 28 4.00703V27.993C28 27.9969 27.9969 28 27.993 28H4.00703C4.00315 28 4 27.9969 4 27.993V4.00703C4 4.00315 4.00315 4 4.00703 4ZM10.6562 12.2031C11.6141 12.2031 12.3906 11.4266 12.3906 10.4688C12.3906 9.51088 11.6141 8.73438 10.6562 8.73438C9.69838 8.73438 8.92188 9.51088 8.92188 10.4688C8.92188 11.4266 9.69838 12.2031 10.6562 12.2031ZM16.9844 14.3321V13.0938H13.8906V22.375H16.9844V16.7695C17.146 16.0035 17.7206 15.3438 18.625 15.3438C19.75 15.3438 20.1719 16.1875 20.1719 17.4531V22.375H23.2656V17.0781C23.2656 14.2188 21.7656 12.9062 19.7031 12.9062C18.1729 12.9062 17.3773 13.7273 16.9844 14.3321ZM9.10938 22.375V13.0938H12.2031V22.375H9.10938Z"
        })
    });
};

// EXTERNAL MODULE: ./src/components/primitives/button/index.tsx
var primitives_button = __webpack_require__(6395);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./src/components/primitives/input/input.module.scss
var input_module = __webpack_require__(3682);
var input_module_default = /*#__PURE__*/__webpack_require__.n(input_module);
;// CONCATENATED MODULE: ./src/components/primitives/input/index.tsx





var Input = function(_param) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread/* default */.Z)({
        className: (0,clsx_m/* default */.Z)((input_module_default()).input, className)
    }, props));
};

// EXTERNAL MODULE: ./src/components/primitives/logo.tsx
var logo = __webpack_require__(1916);
// EXTERNAL MODULE: ./src/hooks/use-device-detect.ts
var use_device_detect = __webpack_require__(2308);
// EXTERNAL MODULE: ./src/hooks/use-media.ts
var use_media = __webpack_require__(4299);
// EXTERNAL MODULE: ./src/lib/constants.ts
var constants = __webpack_require__(7469);
;// CONCATENATED MODULE: ./public/images/home/footer-bg.svg
/* harmony default export */ var footer_bg = ({"src":"/_next/static/media/footer-bg.fad5e337.svg","height":1466,"width":1920});
// EXTERNAL MODULE: ./src/components/layout/footer/footer.module.scss
var footer_module = __webpack_require__(689);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
;// CONCATENATED MODULE: ./src/components/layout/footer/index.tsx





















var links = {
    about: [
        {
            label: "About",
            href: "/about"
        },
        {
            label: "Pricing",
            href: "/pricing"
        },
        {
            label: "We're Hiring",
            href: "/about#jobs"
        },
        {
            label: "Values",
            href: "/about#values"
        }
    ],
    "get help": [
        {
            label: "Docs",
            href: "https://docs.replay.io/"
        },
        {
            label: "Github Issues",
            href: "https://github.com/replayio"
        },
        {
            label: "Contact Us",
            href: "mailto:sales@replay.io"
        }
    ],
    legal: [
        {
            label: "Privacy Policy",
            href: "/privacy-policy"
        },
        {
            label: "Terms of Service",
            href: "/terms-of-service"
        }
    ],
    resources: [
        {
            label: "Blog",
            href: "https://medium.com/replay-io"
        },
        {
            label: "Security & Privacy",
            href: "/security-and-privacy"
        }
    ]
};
var social = {
    discord: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Discord, {}),
        href: "/discord"
    },
    twitter: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Twitter, {}),
        href: "https://twitter.com/replayio"
    },
    linkedIn: {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Linkedin, {}),
        href: "https://www.linkedin.com/company/replayio/"
    }
};
var Footer = function() {
    var router = (0,next_router.useRouter)();
    var progressRef = (0,react.useRef)(null);
    var sectionRef = (0,react.useRef)(null);
    var isDesktopSize = (0,use_media/* useMedia */.G)("(min-width: ".concat(constants/* breakpoints.screenLg */.AV.screenLg, "px)"));
    var isDesktop = (0,use_device_detect/* useDeviceDetect */.d)().isDesktop;
    (0,react.useEffect)(function() {
        if (!sectionRef.current || !progressRef.current) return;
        var trigger = gsap/* ScrollTrigger.create */.ic.create({
            trigger: sectionRef.current,
            markers: false,
            scrub: 1,
            start: "top bottom",
            end: "".concat(isDesktopSize ? "bottom" : "+=600px", " bottom"),
            onUpdate: function(stState) {
                if (progressRef.current) {
                    progressRef.current.update(stState.progress * 70);
                }
            }
        });
        return function() {
            trigger.kill();
        };
    }, [
        isDesktop,
        isDesktopSize
    ]);
    var ref = (0,react.useMemo)(function() {
        var overflowed = false;
        var hidden = false;
        switch(router.pathname){
            case "/about":
            case "/pricing":
                overflowed = true;
                break;
            case "/shoutouts":
            case "/privacy-policy":
            case "/security-and-privacy":
            case "/terms-of-service":
                hidden = true;
                break;
            default:
                break;
        }
        return {
            overflowed: overflowed,
            hidden: hidden
        };
    }, [
        router.pathname
    ]), overflowed = ref.overflowed, hidden = ref.hidden;
    var _obj;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (0,clsx_m/* default */.Z)((footer_module_default()).section, "inverted-selection", (_obj = {}, (0,_define_property/* default */.Z)(_obj, (footer_module_default()).overflowed, overflowed), (0,_define_property/* default */.Z)(_obj, (footer_module_default()).hidden, hidden), _obj)),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (footer_module_default()).bg,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: footer_bg,
                    alt: "footer background"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(container/* Container */.W, {
                size: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (footer_module_default()).footer,
                    ref: sectionRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (footer_module_default()).top,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (footer_module_default()).head,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (footer_module_default()).logo,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: (footer_module_default()).iso,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* IsoLogo */.m, {})
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(heading/* Heading */.X, {
                                                    className: (footer_module_default()).heading,
                                                    size: "lg",
                                                    children: "Start Replaying now"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (footer_module_default()).cta,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_button/* ButtonLink */.Z, {
                                                href: "https://app.replay.io/",
                                                className: (footer_module_default())["play-button"],
                                                size: "sm",
                                                noHover: true,
                                                rounded: true,
                                                variant: "tertiary",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    width: "30",
                                                    height: "31",
                                                    viewBox: "0 0 30 31",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M21.0214 14.6453C21.6595 15.0258 21.6595 15.9742 21.0214 16.3547L10.9406 22.3655C10.3009 22.7469 9.5 22.2718 9.5 21.5107L9.5 9.48927C9.5 8.72824 10.3009 8.25307 10.9406 8.63452L21.0214 14.6453Z",
                                                        fill: "#F41C52"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (footer_module_default()).timeline,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_bar/* ProgressBar */.ko, {
                                        markers: [
                                            {
                                                position: 70
                                            }
                                        ],
                                        primaryColor: "#FFF",
                                        secondaryColor: "#FFFFFF4D",
                                        progress: 70,
                                        direction: "horizontal",
                                        animated: false,
                                        ref: progressRef
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (footer_module_default()).middle,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (footer_module_default())["get-in-touch"],
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (footer_module_default()).title,
                                            children: "Get in touch"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                            placeholder: "Enter your email address",
                                            className: (footer_module_default()).email
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (footer_module_default()).nav,
                                    children: Object.entries(links).map(function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], items = _param[1];
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (footer_module_default())["nav-group"],
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: (footer_module_default()).title,
                                                    children: key
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: (footer_module_default()).list,
                                                    children: items.map(function(param) {
                                                        var label = param.label, href = param.href;
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_link/* Link */.r, {
                                                                href: href,
                                                                children: label
                                                            })
                                                        }, label);
                                                    })
                                                })
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (footer_module_default()).bottom,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (footer_module_default()).rights,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        children: [
                                            "\xa9 ",
                                            new Date().getFullYear(),
                                            " Replay, All rights reserved."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: (footer_module_default()).social,
                                    children: Object.entries(social).map(function(param) {
                                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], link = _param[1];
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            title: key,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_link/* Link */.r, {
                                                href: link.href,
                                                children: link.icon
                                            })
                                        }, key);
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/lodash/throttle.js
var throttle = __webpack_require__(3493);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
// EXTERNAL MODULE: ./src/hooks/use-isomorphic-layout-effect.ts
var use_isomorphic_layout_effect = __webpack_require__(5813);
;// CONCATENATED MODULE: ./src/components/icons/burger.tsx




var Burger = function(param) {
    var className = param.className, fill = param.fill, isOpen = param.isOpen;
    var timelineRef = react.useRef();
    var topRef = react.useRef(null);
    var middleRef = react.useRef(null);
    var bottomRef = react.useRef(null);
    (0,use_isomorphic_layout_effect/* useIsomorphicLayoutEffect */.L)(function() {
        timelineRef.current = gsap/* gsap.timeline */.p8.timeline({
            paused: true,
            reversed: true,
            smoothChildTiming: true
        });
        timelineRef.current.to(topRef.current, {
            y: -4,
            transformOrigin: "50% 50%"
        });
        timelineRef.current.to(bottomRef.current, {
            y: 4,
            transformOrigin: "50% 50%"
        }, "<");
        timelineRef.current.to(middleRef.current, {
            scale: 0.1,
            transformOrigin: "50% 50%"
        }, "<");
        timelineRef.current.add("rotate");
        timelineRef.current.to(topRef.current, {
            y: 6
        }, "rotate");
        timelineRef.current.to(bottomRef.current, {
            y: -6
        }, "rotate");
        timelineRef.current.to(topRef.current, {
            rotationZ: 45,
            transformOrigin: "50% 50%"
        }, "rotate");
        timelineRef.current.to(bottomRef.current, {
            rotationZ: -45,
            transformOrigin: "50% 50%"
        }, "rotate");
        timelineRef.current.timeScale(2.23);
        return function() {
            var ref;
            (ref = timelineRef.current) === null || ref === void 0 ? void 0 : ref.kill();
        };
    }, []);
    (0,use_isomorphic_layout_effect/* useIsomorphicLayoutEffect */.L)(function() {
        if (isOpen) {
            var ref;
            (ref = timelineRef.current) === null || ref === void 0 ? void 0 : ref.play();
        } else {
            var ref1;
            (ref1 = timelineRef.current) === null || ref1 === void 0 ? void 0 : ref1.reverse();
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        className: className,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 18H21",
                stroke: fill || "#000",
                strokeWidth: "2",
                strokeLinecap: "square",
                strokeLinejoin: "round",
                ref: bottomRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 12H21",
                stroke: fill || "#000",
                strokeWidth: "2",
                strokeLinecap: "square",
                strokeLinejoin: "round",
                ref: middleRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3 6H21",
                stroke: fill || "#000",
                strokeWidth: "2",
                strokeLinecap: "square",
                strokeLinejoin: "round",
                ref: topRef
            })
        ]
    });
};
/* harmony default export */ var burger = (Burger);

// EXTERNAL MODULE: ./src/hooks/use-toggle-state.ts
var use_toggle_state = __webpack_require__(6859);
// EXTERNAL MODULE: ./src/components/layout/header/header.module.scss
var header_module = __webpack_require__(5851);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
;// CONCATENATED MODULE: ./src/components/layout/header/index.tsx















var header_link = [
    {
        href: "https://docs.replay.io/docs/why-replay-12b64a4c3b5d461981f1b498fc055d56#6524a5fc96304bf286184e004d2ba55f",
        label: "Use Cases"
    },
    {
        href: "/about",
        label: "About"
    },
    {
        href: "/pricing",
        label: "Pricing"
    },
    {
        href: "/about#jobs",
        label: "We're hiring"
    },
    {
        href: "/discord",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 32 32",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                    clipPath: "url(#clip0_2144_5001)",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M24.3045 8.46995C22.7705 7.76607 21.1255 7.24748 19.4055 6.95046C19.3742 6.94473 19.3429 6.95906 19.3268 6.98771C19.1152 7.36399 18.8809 7.85488 18.7168 8.24072C16.8668 7.96377 15.0264 7.96377 13.2144 8.24072C13.0502 7.84631 12.8074 7.36399 12.5949 6.98771C12.5787 6.96001 12.5474 6.94569 12.5161 6.95046C10.7971 7.24653 9.15207 7.76512 7.61709 8.46995C7.6038 8.47568 7.59241 8.48524 7.58485 8.49764C4.4646 13.1592 3.60983 17.7062 4.02915 22.1969C4.03105 22.2189 4.04338 22.2399 4.06046 22.2532C6.11911 23.7651 8.11327 24.6829 10.0704 25.2912C10.1017 25.3008 10.1349 25.2893 10.1548 25.2635C10.6178 24.6313 11.0305 23.9647 11.3843 23.2637C11.4052 23.2226 11.3853 23.1739 11.3426 23.1577C10.688 22.9093 10.0647 22.6066 9.46513 22.2628C9.4177 22.2351 9.41391 22.1673 9.45754 22.1348C9.58371 22.0402 9.70991 21.9419 9.83039 21.8425C9.85219 21.8244 9.88256 21.8206 9.90819 21.832C13.8471 23.6304 18.1115 23.6304 22.0039 21.832C22.0296 21.8196 22.0599 21.8235 22.0827 21.8416C22.2032 21.9409 22.3294 22.0402 22.4565 22.1348C22.5001 22.1673 22.4973 22.2351 22.4498 22.2628C21.8503 22.6133 21.227 22.9093 20.5714 23.1567C20.5288 23.1729 20.5098 23.2226 20.5307 23.2637C20.8921 23.9637 21.3048 24.6303 21.7592 25.2626C21.7782 25.2893 21.8123 25.3008 21.8436 25.2912C23.8103 24.6829 25.8044 23.7651 27.863 22.2532C27.8811 22.2399 27.8925 22.2198 27.8944 22.1978C28.3962 17.0062 27.0538 12.4964 24.3358 8.49859C24.3292 8.48524 24.3178 8.47568 24.3045 8.46995ZM11.9725 19.4626C10.7866 19.4626 9.80951 18.3738 9.80951 17.0367C9.80951 15.6997 10.7677 14.6109 11.9725 14.6109C13.1868 14.6109 14.1545 15.7092 14.1355 17.0367C14.1355 18.3738 13.1773 19.4626 11.9725 19.4626ZM19.97 19.4626C18.7841 19.4626 17.807 18.3738 17.807 17.0367C17.807 15.6997 18.7651 14.6109 19.97 14.6109C21.1843 14.6109 22.1519 15.7092 22.133 17.0367C22.133 18.3738 21.1843 19.4626 19.97 19.4626Z",
                        fill: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                        id: "clip0_2144_5001",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "24",
                            height: "19.5938",
                            fill: "currentColor",
                            transform: "translate(4 6)"
                        })
                    })
                })
            ]
        }),
        label: "Discord"
    }
];
var Header = function() {
    var menuRef = (0,react.useRef)(null);
    var headerMobileRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), hasScrolled = ref[0], setHasScrolled = ref[1];
    var ref1 = (0,use_toggle_state/* useToggleState */.l)(), isOn = ref1.isOn, handleToggle = ref1.handleToggle;
    var asPath = (0,next_router.useRouter)().asPath;
    (0,react.useEffect)(function() {
        var handleScroll = throttle_default()(function() {
            var offset = 0;
            var scrollTop = document.documentElement.scrollTop;
            var scrolled = scrollTop > offset;
            if (hasScrolled !== scrolled) {
                setHasScrolled(scrolled);
            }
        }, 200);
        document.addEventListener("scroll", handleScroll, {
            passive: true
        });
        return function() {
            document.removeEventListener("scroll", handleScroll);
        };
    }, [
        hasScrolled
    ]);
    (0,react.useEffect)(function() {
        var selector = gsap/* gsap.utils.selector */.p8.utils.selector(menuRef.current);
        var menuInner = selector(".".concat((header_module_default())["menu-inner"]));
        var duration = 0.5;
        if (isOn) {
            gsap/* gsap.to */.p8.to(menuRef.current, {
                "--shadow-opacity": 0.12,
                duration: duration
            });
            gsap/* gsap.fromTo */.p8.fromTo(menuInner, {
                margin: 0,
                height: 0
            }, {
                margin: "24px 0",
                duration: duration,
                height: "auto",
                opacity: 1
            });
        } else {
            gsap/* gsap.to */.p8.to(menuInner, {
                duration: duration,
                height: 0,
                margin: 0,
                opacity: 0
            });
            gsap/* gsap.to */.p8.to(menuRef.current, {
                duration: duration,
                "--shadow-opacity": 0
            });
        }
    }, [
        isOn
    ]);
    (0,use_isomorphic_layout_effect/* useIsomorphicLayoutEffect */.L)(function() {
        if (isOn) {
            gsap/* gsap.set */.p8.set("body", {
                overflow: "hidden"
            });
        } else {
            gsap/* gsap.set */.p8.set("body", {
                overflow: "unset"
            });
        }
    }, [
        isOn
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
        className: (0,clsx_m/* default */.Z)((header_module_default()).header, (0,_define_property/* default */.Z)({}, (header_module_default())["has-scrolled"], hasScrolled)),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* Container */.W, {
            size: "md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (header_module_default())["inner-mobile"],
                    ref: headerMobileRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (header_module_default())["mobile-wrapper"],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_link/* Link */.r, {
                                    href: "/",
                                    "aria-label": "Go Home",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {
                                        width: 80,
                                        className: (header_module_default()).logo
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (header_module_default()).burger,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_button/* Button */.z, {
                                        onClick: handleToggle,
                                        unstyled: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(burger, {
                                            isOpen: isOn,
                                            fill: "#464646"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default()).menu,
                            ref: menuRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* Container */.W, {
                                className: (header_module_default())["menu-inner"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: header_link.map(function(param) {
                                            var href = param.href, icon = param.icon, label = param.label;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_link/* Link */.r, {
                                                    href: href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: (0,clsx_m/* default */.Z)((header_module_default())["nav-link"], (0,_define_property/* default */.Z)({}, (header_module_default()).active, href === asPath)),
                                                        children: [
                                                            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: (header_module_default()).icon,
                                                                children: icon
                                                            }),
                                                            label
                                                        ]
                                                    })
                                                })
                                            }, label);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_button/* ButtonLink */.Z, {
                                        href: "https://app.replay.io/",
                                        size: "md",
                                        variant: "secondary",
                                        children: "Login"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (header_module_default())["inner-desktop"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_link/* Link */.r, {
                            href: "/",
                            "aria-label": "Go Home",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo/* Logo */.T, {
                                width: 94,
                                className: (header_module_default()).logo
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default()).nav,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: header_link.map(function(param) {
                                    var href = param.href, icon = param.icon, label = param.label;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_link/* Link */.r, {
                                            href: href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                className: (0,clsx_m/* default */.Z)((header_module_default())["nav-link"], (0,_define_property/* default */.Z)({}, (header_module_default()).active, href === asPath)),
                                                children: [
                                                    icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: (header_module_default()).icon,
                                                        children: icon
                                                    }),
                                                    label
                                                ]
                                            })
                                        })
                                    }, label);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_button/* ButtonLink */.Z, {
                                href: "https://app.replay.io/",
                                size: "sm",
                                variant: "secondary",
                                children: "Login"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/layout/page.tsx








var PageLayout = function(param) {
    var children = param.children;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), is404 = ref[0], setIs404 = ref[1];
    (0,react.useEffect)(function() {
        if (!router.pathname) return;
        gsap/* ScrollTrigger.sort */.ic.sort();
        gsap/* ScrollTrigger.refresh */.ic.refresh();
        if (router.pathname === "/404") {
            setIs404(true);
        } else {
            setIs404(false);
        }
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnnouncementBar, {
                text: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Proudly backed by Andreessen Horowitz.",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives_link/* Link */.r, {
                            href: "https://medium.com/replay-io/launching-replay-the-time-travel-debugger-for-the-web-f886f0897d38",
                            children: "Read\xa0More"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            }),
            !is404 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {})
        ]
    });
};


/***/ }),

/***/ 6395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ButtonLink; },
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _lib_utils_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6102);
/* harmony import */ var _link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3761);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(555);
/* harmony import */ var _button_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_button_module_scss__WEBPACK_IMPORTED_MODULE_8__);










var Button = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var as = _param.as, children = _param.children, _variant = _param.variant, variant = _variant === void 0 ? "secondary" : _variant, _unstyled = _param.unstyled, unstyled = _unstyled === void 0 ? false : _unstyled, _size = _param.size, size = _size === void 0 ? "md" : _size, _rounded = _param.rounded, rounded = _rounded === void 0 ? false : _rounded, className = _param.className, _noHover = _param.noHover, noHover = _noHover === void 0 ? false : _noHover, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "as",
        "children",
        "variant",
        "unstyled",
        "size",
        "rounded",
        "className",
        "noHover"
    ]);
    var Comp = as || "button";
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default().button), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, (_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default().rounded), rounded), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, (_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default().unstyled), unstyled), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_obj, (_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["no-hover"]), noHover), _obj), (_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[variant], (_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default())[size], className)
    }, rest), {
        ref: ref,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: (_button_module_scss__WEBPACK_IMPORTED_MODULE_8___default().content),
            children: children
        })
    }));
});
var ButtonLink = function(_param) {
    var href = _param.href, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "href"
    ]);
    var externalProps = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var p = {
            target: "_blank",
            rel: "noopener"
        };
        if (typeof href === "string") {
            if ((0,_lib_utils_router__WEBPACK_IMPORTED_MODULE_2__/* .checkIsExternal */ .X5)(href)) return p;
        }
    }, [
        href
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_link__WEBPACK_IMPORTED_MODULE_3__/* .Link */ .r, {
        href: href,
        asChild: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            as: "a"
        }, externalProps, rest))
    });
};


/***/ }),

/***/ 3761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6010);
/* harmony import */ var lib_utils_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6102);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var _link_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9451);
/* harmony import */ var _link_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_link_module_scss__WEBPACK_IMPORTED_MODULE_8__);










var Link = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(_param, ref) {
    var children = _param.children, className = _param.className, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "className"
    ]);
    var href = restProps.href, // NextLink Props
    replace = restProps.replace, _scroll = restProps.scroll, scroll = _scroll === void 0 ? true : _scroll, shallow = restProps.shallow, prefetch = restProps.prefetch, _unstyled = restProps.unstyled, unstyled = _unstyled === void 0 ? false : _unstyled, asChild = restProps.asChild, aProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(restProps, [
        "href",
        "replace",
        "scroll",
        "shallow",
        "prefetch",
        "unstyled",
        "asChild"
    ]);
    var isExternal = (0,lib_utils_router__WEBPACK_IMPORTED_MODULE_1__/* .checkIsExternal */ .X5)(href);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
        href: href,
        replace: replace,
        scroll: scroll,
        shallow: shallow,
        prefetch: prefetch,
        passHref: true,
        children: !asChild ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            target: isExternal ? "_blank" : undefined,
            rel: isExternal ? "noopener" : undefined
        }, aProps), {
            ref: ref,
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((_link_module_scss__WEBPACK_IMPORTED_MODULE_8___default().link), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, (_link_module_scss__WEBPACK_IMPORTED_MODULE_8___default().unstyled), unstyled), className),
            children: children
        })) : children
    });
});


/***/ }),

/***/ 1916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; },
/* harmony export */   "m": function() { return /* binding */ IsoLogo; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);






var IsoLogo = function(_param) {
    var rest = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _param);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 52 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M23.2826 11.9545L13.6931 6.40771L4.10349 0.86089C3.68759 0.620535 3.21588 0.49405 2.73574 0.494141C2.2556 0.494231 1.78394 0.620894 1.36813 0.861405C0.952315 1.10192 0.606999 1.44781 0.366851 1.86434C0.126704 2.28088 0.000181045 2.75338 0 3.2344V25.4215C0.000161455 25.9025 0.126671 26.375 0.36681 26.7916C0.60695 27.2081 0.952264 27.554 1.36808 27.7946C1.78389 28.0351 2.25557 28.1617 2.73572 28.1618C3.21586 28.1619 3.68758 28.0355 4.10349 27.7951L13.6931 22.2483L23.2826 16.7016C23.6985 16.461 24.0439 16.1151 24.284 15.6984C24.5241 15.2818 24.6505 14.8091 24.6505 14.328C24.6505 13.8469 24.5241 13.3743 24.284 12.9577C24.0439 12.541 23.6985 12.1951 23.2826 11.9545Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M23.2826 42.8509L13.6931 37.3042L4.10349 31.7574C3.68758 31.517 3.21586 31.3905 2.73571 31.3906C2.25556 31.3907 1.78389 31.5174 1.36808 31.7579C0.952264 31.9984 0.606943 32.3444 0.366803 32.7609C0.126664 33.1774 0.000161455 33.65 0 34.131V56.3179C0.000161455 56.799 0.126664 57.2715 0.366803 57.6881C0.606943 58.1046 0.952264 58.4505 1.36808 58.691C1.78389 58.9316 2.25556 59.0582 2.73571 59.0583C3.21586 59.0584 3.68758 58.9319 4.10349 58.6916L13.6931 53.1449L23.2826 47.598C23.6985 47.3575 24.0439 47.0115 24.2841 46.5949C24.5242 46.1782 24.6506 45.7056 24.6506 45.2245C24.6506 44.7434 24.5242 44.2707 24.2841 43.8541C24.0439 43.4374 23.6985 43.0914 23.2826 42.8509Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M50.6303 27.4036L41.0408 21.8568L31.4511 16.3101C31.0352 16.0698 30.5635 15.9433 30.0834 15.9434C29.6033 15.9435 29.1316 16.0701 28.7158 16.3106C28.3 16.5511 27.9546 16.897 27.7145 17.3136C27.4744 17.7301 27.3478 18.2026 27.3477 18.6836V40.8707C27.3478 41.3517 27.4744 41.8242 27.7145 42.2408C27.9546 42.6573 28.3 43.0032 28.7158 43.2437C29.1316 43.4842 29.6033 43.6109 30.0834 43.611C30.5635 43.611 31.0352 43.4846 31.4511 43.2442L41.0408 37.6975L50.6303 32.1507C51.0462 31.9101 51.3916 31.5642 51.6317 31.1475C51.8718 30.7309 51.9982 30.2583 51.9982 29.7772C51.9982 29.2961 51.8718 28.8234 51.6317 28.4068C51.3916 27.9901 51.0462 27.6442 50.6303 27.4036Z",
                fill: "currentColor"
            })
        ]
    }));
};
var Logo = function(_param) {
    var _width = _param.width, width = _width === void 0 ? 94 : _width, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "width"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: width,
        viewBox: "0 0 94 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.0154 6.18409L7.27252 3.44068L2.52956 0.697261C2.32385 0.578383 2.09055 0.515824 1.85308 0.515869C1.61561 0.515914 1.38232 0.57856 1.17667 0.697516C0.971008 0.816471 0.800217 0.987547 0.681442 1.19356C0.562667 1.39958 0.50009 1.63327 0.5 1.87118V12.8447C0.50008 13.0827 0.56265 13.3164 0.681422 13.5224C0.800193 13.7284 0.970983 13.8995 1.17664 14.0185C1.3823 14.1374 1.61559 14.2001 1.85307 14.2001C2.09054 14.2002 2.32385 14.1376 2.52956 14.0187L7.27252 11.2753L12.0154 8.53195C12.2211 8.41298 12.3919 8.24186 12.5107 8.03579C12.6295 7.82973 12.692 7.59597 12.692 7.35802C12.692 7.12007 12.6295 6.88631 12.5107 6.68024C12.3919 6.47418 12.2211 6.30306 12.0154 6.18409Z",
                fill: "#F41C52"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.0154 21.4651L7.27251 18.7217L2.52956 15.9783C2.32385 15.8594 2.09054 15.7969 1.85306 15.7969C1.61558 15.797 1.3823 15.8596 1.17664 15.9786C0.970983 16.0976 0.80019 16.2686 0.681418 16.4747C0.562647 16.6807 0.50008 16.9144 0.5 17.1523V28.1258C0.50008 28.3637 0.562647 28.5974 0.681418 28.8035C0.80019 29.0095 0.970983 29.1806 1.17664 29.2995C1.3823 29.4185 1.61558 29.4811 1.85306 29.4812C2.09054 29.4812 2.32385 29.4187 2.52956 29.2998L7.27251 26.5564L12.0154 23.813C12.2211 23.6941 12.392 23.5229 12.5107 23.3169C12.6295 23.1108 12.692 22.877 12.692 22.6391C12.692 22.4011 12.6295 22.1673 12.5107 21.9613C12.392 21.7552 12.2211 21.5841 12.0154 21.4651Z",
                fill: "#F41C52"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M25.5424 13.8261L20.7995 11.0827L16.0565 8.33935C15.8508 8.22047 15.6175 8.15791 15.3801 8.15796C15.1426 8.158 14.9093 8.22065 14.7036 8.33961C14.498 8.45856 14.3272 8.62964 14.2084 8.83565C14.0896 9.04167 14.0271 9.27536 14.027 9.51327V20.4868C14.0271 20.7247 14.0896 20.9584 14.2084 21.1645C14.3272 21.3705 14.498 21.5416 14.7036 21.6605C14.9093 21.7795 15.1426 21.8421 15.3801 21.8422C15.6175 21.8422 15.8508 21.7796 16.0565 21.6608L20.7995 18.9174L25.5424 16.174C25.7481 16.055 25.9189 15.8839 26.0377 15.6778C26.1564 15.4718 26.219 15.238 26.219 15.0001C26.219 14.7621 26.1564 14.5283 26.0377 14.3223C25.9189 14.1162 25.7481 13.9451 25.5424 13.8261Z",
                fill: "#F41C52"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M38.3162 19.7427V6.54565H42.7753C43.8064 6.54565 44.6527 6.72179 45.3142 7.07405C45.9758 7.42202 46.4655 7.90102 46.7834 8.51104C47.1013 9.12106 47.2603 9.81485 47.2603 10.5924C47.2603 11.37 47.1013 12.0595 46.7834 12.6609C46.4655 13.2623 45.9779 13.7349 45.3207 14.0786C44.6634 14.4179 43.8235 14.5876 42.8011 14.5876H39.1925V13.1442H42.7496C43.4541 13.1442 44.0212 13.0411 44.4507 12.8349C44.8846 12.6287 45.1982 12.3366 45.3916 11.9585C45.5892 11.5762 45.688 11.1208 45.688 10.5924C45.688 10.064 45.5892 9.60221 45.3916 9.20698C45.1939 8.81176 44.8782 8.50674 44.4443 8.29195C44.0104 8.07286 43.4369 7.96331 42.7238 7.96331H39.9142V19.7427H38.3162ZM44.5281 13.8144L47.7758 19.7427H45.92L42.7238 13.8144H44.5281Z",
                fill: "#F41C52"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M53.7606 19.9489C52.8069 19.9489 51.9842 19.7384 51.2925 19.3174C50.6052 18.8921 50.0746 18.2993 49.7009 17.5389C49.3315 16.7743 49.1467 15.885 49.1467 14.8712C49.1467 13.8573 49.3315 12.9638 49.7009 12.1905C50.0746 11.4129 50.5945 10.8072 51.2603 10.3733C51.9305 9.93514 52.7123 9.71605 53.6059 9.71605C54.1214 9.71605 54.6305 9.80197 55.1331 9.9738C55.6357 10.1456 56.0932 10.4249 56.5056 10.8115C56.9181 11.1938 57.2467 11.7008 57.4916 12.3323C57.7364 12.9638 57.8589 13.7413 57.8589 14.665V15.3093H50.2293V13.9948H56.3123C56.3123 13.4363 56.2006 12.938 55.9772 12.4998C55.7582 12.0616 55.4446 11.7158 55.0364 11.4623C54.6326 11.2089 54.1558 11.0822 53.6059 11.0822C53.0002 11.0822 52.4761 11.2325 52.0336 11.5332C51.5954 11.8296 51.2582 12.2163 51.0219 12.6931C50.7856 13.17 50.6675 13.6812 50.6675 14.2268V15.1031C50.6675 15.8506 50.7964 16.4843 51.0541 17.0041C51.3162 17.5196 51.6792 17.9127 52.1431 18.1833C52.6071 18.4497 53.1462 18.5828 53.7606 18.5828C54.1601 18.5828 54.5209 18.527 54.8431 18.4153C55.1696 18.2993 55.451 18.1275 55.6873 17.8998C55.9236 17.6678 56.1061 17.38 56.235 17.0363L57.7042 17.4487C57.5496 17.947 57.2897 18.3852 56.9245 18.7633C56.5593 19.137 56.1083 19.4291 55.5713 19.6396C55.0343 19.8458 54.4307 19.9489 53.7606 19.9489Z",
                fill: "#F41C52"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M60.1722 23.4544V9.84493H61.6414V11.4172H61.8219C61.9335 11.2454 62.0882 11.0263 62.2858 10.76C62.4877 10.4893 62.7756 10.2487 63.1493 10.0382C63.5273 9.82345 64.0386 9.71605 64.6829 9.71605C65.5164 9.71605 66.251 9.9244 66.8868 10.3411C67.5226 10.7578 68.0187 11.3485 68.3753 12.1132C68.7319 12.8778 68.9101 13.78 68.9101 14.8196C68.9101 15.8678 68.7319 16.7764 68.3753 17.5454C68.0187 18.31 67.5247 18.9029 66.8932 19.3239C66.2617 19.7406 65.5335 19.9489 64.7087 19.9489C64.0729 19.9489 63.5639 19.8437 63.1815 19.6332C62.7992 19.4184 62.5049 19.1757 62.2987 18.905C62.0925 18.6301 61.9335 18.4024 61.8219 18.222H61.693V23.4544H60.1722ZM61.6672 14.7938C61.6672 15.5413 61.7767 16.2007 61.9958 16.7721C62.2149 17.3392 62.535 17.7838 62.956 18.106C63.377 18.4239 63.8925 18.5828 64.5025 18.5828C65.1383 18.5828 65.6689 18.4153 66.0942 18.0802C66.5237 17.7408 66.8459 17.2855 67.0607 16.7141C67.2798 16.1385 67.3894 15.4984 67.3894 14.7938C67.3894 14.0979 67.282 13.4707 67.0672 12.9122C66.8567 12.3495 66.5366 11.9048 66.107 11.5783C65.6817 11.2475 65.1469 11.0822 64.5025 11.0822C63.8839 11.0822 63.3641 11.239 62.9431 11.5526C62.5221 11.8619 62.2042 12.2958 61.9894 12.8542C61.7746 13.4084 61.6672 14.0549 61.6672 14.7938Z",
                fill: "#F41C52"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M72.7507 6.54565V19.7427H71.2299V6.54565H72.7507Z",
                fill: "#F41C52"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M78.4487 19.9747C77.8215 19.9747 77.2523 19.8566 76.7411 19.6203C76.2299 19.3797 75.8239 19.0339 75.5232 18.5828C75.2225 18.1275 75.0721 17.5776 75.0721 16.9332C75.0721 16.3661 75.1838 15.9065 75.4072 15.5542C75.6306 15.1976 75.9291 14.9184 76.3029 14.7165C76.6766 14.5146 77.089 14.3642 77.5401 14.2654C77.9955 14.1623 78.453 14.0807 78.9127 14.0206C79.5141 13.9432 80.0017 13.8852 80.3754 13.8466C80.7535 13.8036 81.0284 13.7327 81.2002 13.6339C81.3764 13.5351 81.4644 13.3633 81.4644 13.1184V13.0669C81.4644 12.4311 81.2905 11.937 80.9425 11.5848C80.5988 11.2325 80.0769 11.0564 79.3766 11.0564C78.6506 11.0564 78.0814 11.2153 77.669 11.5332C77.2566 11.8511 76.9666 12.1905 76.7991 12.5514L75.3556 12.0358C75.6134 11.4344 75.9571 10.9662 76.3867 10.6311C76.8205 10.2917 77.2931 10.0554 77.8043 9.92225C78.3198 9.78478 78.8267 9.71605 79.3251 9.71605C79.643 9.71605 80.0081 9.75471 80.4205 9.83204C80.8372 9.90507 81.2389 10.0576 81.6255 10.2896C82.0165 10.5215 82.3408 10.8717 82.5986 11.3399C82.8563 11.8082 82.9852 12.4354 82.9852 13.2215V19.7427H81.4644V18.4024H81.3871C81.284 18.6172 81.1122 18.847 80.8716 19.0919C80.631 19.3368 80.311 19.5451 79.9115 19.717C79.5119 19.8888 79.0244 19.9747 78.4487 19.9747ZM78.6807 18.6086C79.2821 18.6086 79.789 18.4905 80.2014 18.2542C80.6181 18.0179 80.9317 17.7129 81.1422 17.3392C81.357 16.9654 81.4644 16.5723 81.4644 16.1599V14.7681C81.4 14.8454 81.2582 14.9163 81.0391 14.9807C80.8243 15.0408 80.5752 15.0945 80.2916 15.1418C80.0124 15.1848 79.7396 15.2234 79.4733 15.2578C79.2112 15.2879 78.9986 15.3136 78.8353 15.3351C78.4401 15.3867 78.0707 15.4704 77.727 15.5864C77.3876 15.6981 77.1127 15.8678 76.9022 16.0955C76.696 16.3189 76.5929 16.6239 76.5929 17.0105C76.5929 17.5389 76.7883 17.9384 77.1793 18.2091C77.5745 18.4754 78.075 18.6086 78.6807 18.6086Z",
                fill: "#F41C52"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M86.386 23.4544C86.1282 23.4544 85.8984 23.4329 85.6965 23.39C85.4946 23.3513 85.3549 23.3127 85.2776 23.274L85.6642 21.9337C86.0337 22.0282 86.3602 22.0625 86.6437 22.0368C86.9272 22.011 87.1786 21.8843 87.3976 21.6566C87.621 21.4332 87.8251 21.0702 88.0098 20.5676L88.2934 19.7943L84.6332 9.84493H86.2829L89.0151 17.7322H89.1182L91.8504 9.84493H93.5L89.2986 21.1862C89.1096 21.6974 88.8754 22.1205 88.5962 22.4556C88.317 22.795 87.9926 23.0463 87.6232 23.2096C87.258 23.3728 86.8456 23.4544 86.386 23.4544Z",
                fill: "#F41C52"
            })
        ]
    }));
};


/***/ }),

/***/ 2308:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ useDeviceDetect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7954);



var hydrated = false;
function getDD() {
    var isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0 || // @ts-ignore
    navigator.msMaxTouchPoints > 0;
    var isIpadPro = react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isDesktop */ .nI && react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isSafari */ .G6 && isTouchDevice;
    return {
        isDesktop: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isDesktop */ .nI && !isIpadPro,
        isMobile: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isMobile */ .tq || isIpadPro,
        isMobileOnly: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isMobileOnly */ .UA,
        isMobileSafari: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isMobileSafari */ .TL,
        isTablet: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isTablet */ .Em || isIpadPro,
        isChrome: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isChrome */ .i7,
        isFirefox: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isFirefox */ .vU,
        isSafari: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isSafari */ .G6,
        isMacOs: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isMacOs */ .Q5,
        isWindows: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isWindows */ .ED,
        isIOS: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isIOS */ .gn,
        isAndroid: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isAndroid */ .Dt,
        isBrowser: react_device_detect__WEBPACK_IMPORTED_MODULE_1__/* .isBrowser */ .jU,
        isTouch: isTouchDevice
    };
}
var useDeviceDetect = function() {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(function() {
        return hydrated ? getDD() : {};
    }), 2), dd = ref[0], set = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        set(getDD());
        hydrated = true;
    }, []);
    return dd;
};


/***/ }),

/***/ 3311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useGsapTime; }
/* harmony export */ });
/* harmony import */ var lib_gsap__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8997);
/* harmony import */ var lodash_clamp__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4691);
/* harmony import */ var lodash_clamp__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_clamp__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21);




var useGsapTime = function(param) {
    var onStart = param.onStart, onUpdate = param.onUpdate, onComplete = param.onComplete, _loop = param.loop, loop = _loop === void 0 ? false : _loop, duration = param.duration;
    var currentPauseTime = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var startTime = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var api = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var update = function() {
            if (!startTime.current) return;
            var currentTime = new Date().getTime();
            var timeDiff = currentTime - startTime.current;
            var clampedTimeDiff = lodash_clamp__WEBPACK_IMPORTED_MODULE_1___default()(timeDiff, 0, (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__/* .secsToMs */ ._j)(duration));
            var timePassed = (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__/* .msToSecs */ .Fg)(clampedTimeDiff);
            var percentage = timePassed / duration * 100;
            onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate({
                time: timePassed,
                percentage: percentage,
                normalizedTime: timePassed / duration
            });
            if (percentage === 100) {
                onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                if (loop) {
                    api.restart();
                } else {
                    api.pause();
                }
            }
        };
        var shiftStartTime = function(targetTime) {
            if (!startTime.current) return;
            var currentTime = new Date().getTime();
            var currentTimeDiff = currentTime - startTime.current;
            var nextDiff = targetTime - currentTimeDiff;
            startTime.current = startTime.current - nextDiff;
        };
        var api = {
            start: function() {
                startTime.current = new Date().getTime();
                currentPauseTime.current = undefined;
                onStart === null || onStart === void 0 ? void 0 : onStart();
                update();
                lib_gsap__WEBPACK_IMPORTED_MODULE_0__/* .gsap.ticker.add */ .p8.ticker.add(update);
            },
            pause: function() {
                if (!currentPauseTime.current) {
                    currentPauseTime.current = new Date().getTime();
                }
                lib_gsap__WEBPACK_IMPORTED_MODULE_0__/* .gsap.ticker.remove */ .p8.ticker.remove(update);
            },
            resume: function() {
                if (currentPauseTime.current && startTime.current) {
                    shiftStartTime(currentPauseTime.current - startTime.current);
                    currentPauseTime.current = undefined;
                }
                lib_gsap__WEBPACK_IMPORTED_MODULE_0__/* .gsap.ticker.add */ .p8.ticker.add(update);
            },
            restart: function() {
                api.pause();
                api.start();
            },
            reset: function() {
                api.pause();
                currentPauseTime.current = undefined;
                startTime.current = new Date().getTime();
                update();
            },
            seek: function(percentage) {
                if (!startTime.current) return;
                currentPauseTime.current = undefined;
                var nextDuration = (0,_lib_utils__WEBPACK_IMPORTED_MODULE_3__/* .secsToMs */ ._j)(percentage / 100 * duration);
                shiftStartTime(nextDuration);
                update();
            }
        };
        return api;
    }, [
        duration,
        loop,
        onComplete,
        onUpdate,
        onStart
    ]);
    return api;
};


/***/ }),

/***/ 5813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useIsomorphicLayoutEffect; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7469);


var useIsomorphicLayoutEffect = _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .isClient */ .C5 ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;


/***/ }),

/***/ 4299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ useMedia; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _lib_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);



var useMedia = function(mediaQuery, initialValue) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(initialValue), 2), isVerified = ref[0], setIsVerified = ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        if (!(0,_lib_utils__WEBPACK_IMPORTED_MODULE_1__/* .isApiSupported */ .Q3)("matchMedia")) {
            console.warn("matchMedia is not supported by your current browser");
            return;
        }
        var mediaQueryList = window.matchMedia(mediaQuery);
        var changeHandler = function() {
            return setIsVerified(!!mediaQueryList.matches);
        };
        changeHandler();
        if (typeof mediaQueryList.addEventListener === "function") {
            mediaQueryList.addEventListener("change", changeHandler);
            return function() {
                mediaQueryList.removeEventListener("change", changeHandler);
            };
        } else if (typeof mediaQueryList.addListener === "function") {
            mediaQueryList.addListener(changeHandler);
            return function() {
                mediaQueryList.removeListener(changeHandler);
            };
        }
    }, [
        mediaQuery
    ]);
    return isVerified;
};


/***/ }),

/***/ 6859:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ useToggleState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


var useToggleState = function() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(initialState), 2), isOn = ref[0], setIsOn = ref[1];
    var handleOn = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        setIsOn(true);
    }, []);
    var handleOff = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        setIsOn(false);
    }, []);
    var handleToggle = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        setIsOn(function(p) {
            return !p;
        });
    }, []);
    return {
        isOn: isOn,
        handleToggle: handleToggle,
        handleOn: handleOn,
        handleOff: handleOff
    };
};


/***/ }),

/***/ 8860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useViewportSize; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7469);


var CALL_THRESHOLD_MS = 500;
var useViewportSize = function() {
    var callTreshhold = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        callTreshhold: CALL_THRESHOLD_MS
    }).callTreshhold;
    var resizeTimeout = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .isClient */ .C5 ? window.innerWidth : 0,
        height: _lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .isClient */ .C5 ? window.innerHeight : 0
    }), windowSize = ref[0], setWindowSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function() {
            if (resizeTimeout.current) {
                clearTimeout(resizeTimeout.current);
            }
            resizeTimeout.current = setTimeout(function() {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight
                });
            }, callTreshhold);
        };
        window.addEventListener("resize", handleResize, {
            passive: true
        });
        handleResize();
        return function() {
            window.removeEventListener("resize", handleResize);
            if (resizeTimeout.current) {
                clearTimeout(resizeTimeout.current);
            }
        };
    }, [
        callTreshhold
    ]);
    return windowSize;
};


/***/ }),

/***/ 8997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BW": function() { return /* reexport safe */ gsap_dist_Flip__WEBPACK_IMPORTED_MODULE_7__.Flip; },
/* harmony export */   "C2": function() { return /* reexport safe */ gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_8__.SplitText; },
/* harmony export */   "ic": function() { return /* reexport safe */ gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_5__.ScrollTrigger; },
/* harmony export */   "p8": function() { return /* reexport safe */ gsap__WEBPACK_IMPORTED_MODULE_1__.ZP; },
/* harmony export */   "th": function() { return /* binding */ DURATION; },
/* harmony export */   "ze": function() { return /* binding */ clearProps; }
/* harmony export */ });
/* unused harmony exports GOLDEN_RATIO, GSDevTools */
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(990);
/* harmony import */ var gsap_dist_CSSRulePlugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4728);
/* harmony import */ var gsap_dist_CSSRulePlugin__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_CSSRulePlugin__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var gsap_dist_CustomEase__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4347);
/* harmony import */ var gsap_dist_CustomEase__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_CustomEase__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var gsap_dist_DrawSVGPlugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7749);
/* harmony import */ var gsap_dist_DrawSVGPlugin__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_DrawSVGPlugin__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var gsap_dist_Flip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5341);
/* harmony import */ var gsap_dist_Flip__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_Flip__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6546);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2757);
/* harmony import */ var gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var gsap_dist_TextPlugin__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6403);
/* harmony import */ var gsap_dist_TextPlugin__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_TextPlugin__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var lodash_isElement__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7191);
/* harmony import */ var lodash_isElement__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isElement__WEBPACK_IMPORTED_MODULE_0__);









var GSDevTools;
if (false) {}
gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].registerPlugin */ .ZP.registerPlugin(gsap_dist_CSSRulePlugin__WEBPACK_IMPORTED_MODULE_2__.CSSRulePlugin, gsap_dist_CustomEase__WEBPACK_IMPORTED_MODULE_3__.CustomEase, gsap_dist_DrawSVGPlugin__WEBPACK_IMPORTED_MODULE_4__.DrawSVGPlugin, gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_5__.ScrollTrigger, gsap_dist_TextPlugin__WEBPACK_IMPORTED_MODULE_6__.TextPlugin, gsap_dist_Flip__WEBPACK_IMPORTED_MODULE_7__.Flip, gsap_dist_SplitText__WEBPACK_IMPORTED_MODULE_8__.SplitText);
var GOLDEN_RATIO = (1 + Math.sqrt(5)) / 2;
var RECIPROCAL_GR = 1 / GOLDEN_RATIO;
var DURATION = RECIPROCAL_GR * 0.8;
var ease = gsap_dist_CustomEase__WEBPACK_IMPORTED_MODULE_3__.CustomEase.create("custom", "M0,0 C0.30,0.35 0.40,1 1,1");
gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].config */ .ZP.config({
    autoSleep: 60,
    nullTargetWarn: false
});
gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].defaults */ .ZP.defaults({
    ease: ease,
    duration: DURATION
});
gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].registerEffect */ .ZP.registerEffect({
    name: "fadeIn",
    extendTimeline: true,
    defaults: {
        delay: 0,
        duration: DURATION,
        scale: 1,
        stagger: DURATION / 8,
        y: 30
    },
    effect: function(targets, config) {
        var tl = gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].timeline */ .ZP.timeline();
        tl.from(targets, {
            autoAlpha: 0,
            delay: config.delay,
            duration: config.duration,
            ease: config.ease,
            stagger: config.stagger,
            scale: config.scale,
            y: config.y
        });
        return tl;
    }
});
gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].registerEffect */ .ZP.registerEffect({
    name: "fadeInScale",
    extendTimeline: true,
    defaults: {
        delay: 0,
        duration: DURATION,
        scale: 0.4,
        stagger: DURATION / 6,
        y: 30
    },
    effect: function(targets, config) {
        var tl = gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].timeline */ .ZP.timeline();
        tl.from(targets, {
            autoAlpha: 0,
            delay: config.delay,
            duration: config.duration,
            ease: config.ease,
            stagger: config.stagger,
            scale: config.scale,
            y: config.y
        });
        return tl;
    }
});
gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].registerEffect */ .ZP.registerEffect({
    name: "in",
    extendTimeline: true,
    defaults: {
        duration: DURATION,
        each: DURATION / 23,
        ease: ease,
        fade: DURATION / 2,
        from: "start",
        scale: 1,
        staggerEase: ease,
        x: 0,
        xPercent: 0,
        y: 0,
        yPercent: 30
    },
    effect: function(targets, config) {
        var tl = gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].timeline */ .ZP.timeline();
        tl.from(targets, {
            duration: config.duration,
            ease: config.ease,
            scale: config.scale,
            x: config.x,
            xPercent: config.xPercent,
            y: config.y,
            yPercent: config.yPercent,
            stagger: {
                each: config.each,
                ease: config.staggerEase,
                from: config.from
            }
        });
        tl.from(targets, {
            duration: config.fade,
            ease: "none",
            opacity: 0,
            stagger: {
                each: config.each,
                ease: config.staggerEase,
                from: config.from
            }
        }, 0);
        return tl;
    }
});
gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].registerEffect */ .ZP.registerEffect({
    name: "pulse",
    effect: function(targets, config) {
        return gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(targets, {
            keyframes: {
                "0%": {
                    scale: 1
                },
                "50%": {
                    scale: 1.05
                },
                "100%": {
                    scale: 1
                },
                ease: "power2.inOut"
            },
            duration: config.duration,
            repeat: config.repeat
        });
    },
    defaults: {
        duration: 1,
        repeat: -1
    },
    extendTimeline: true
});
gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].registerEffect */ .ZP.registerEffect({
    name: "flash",
    effect: function(targets, config) {
        return gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].to */ .ZP.to(targets, {
            keyframes: {
                "0%": {
                    autoAlpha: 1
                },
                "25%": {
                    autoAlpha: 0
                },
                "50%": {
                    autoAlpha: 1
                },
                "75%": {
                    autoAlpha: 0
                },
                "100%": {
                    autoAlpha: 1
                },
                ease: "none"
            },
            duration: config.duration,
            repeat: config.repeat
        });
    },
    defaults: {
        duration: DURATION * 2,
        repeat: -1
    },
    extendTimeline: true
});
var isLegible = function(target) {
    return lodash_isElement__WEBPACK_IMPORTED_MODULE_0___default()(target);
};
var clearProps = function(target) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "all";
    var filteredTargets;
    if (Array.isArray(target)) {
        filteredTargets = target.filter(isLegible);
    } else {
        filteredTargets = target;
    }
    return gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].set */ .ZP.set(filteredTargets, {
        clearProps: props
    });
};



/***/ }),

/***/ 21:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ rangeMap; },
/* harmony export */   "Fg": function() { return /* binding */ msToSecs; },
/* harmony export */   "Kz": function() { return /* binding */ padZeroesToNumber; },
/* harmony export */   "Pl": function() { return /* binding */ processString; },
/* harmony export */   "Q3": function() { return /* binding */ isApiSupported; },
/* harmony export */   "_j": function() { return /* binding */ secsToMs; },
/* harmony export */   "xX": function() { return /* binding */ userTagRegex; },
/* harmony export */   "z3": function() { return /* binding */ mdCodeRegex; }
/* harmony export */ });
/* unused harmony exports formatError, getSizes */
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2670);
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7469);


var formatError = function(error) {
    try {
        if (_instanceof(error, Error)) {
            return {
                message: error.message,
                name: error.name
            };
        }
        return {
            message: String(error)
        };
    } catch (error1) {
        return {
            message: "An unknown error ocurred."
        };
    }
};
var isApiSupported = function(api) {
    return _lib_constants__WEBPACK_IMPORTED_MODULE_0__/* .isClient */ .C5 && api in window;
};
/* Builds responsive sizes string for images */ var getSizes = function(entries) {
    var sizes = entries.map(function(entry) {
        if (!entry) {
            return "";
        }
        if (typeof entry === "string") {
            return entry;
        }
        if (typeof entry === "number") {
            return "".concat(entry, "px");
        }
        if (entry.breakpoint.includes("px") || entry.breakpoint.includes("rem")) {
            return "(min-width: ".concat(entry.breakpoint, ") ").concat(entry.width);
        }
        throw new Error("Invalid breakpoint: ".concat(entry.breakpoint));
    });
    return sizes.join(", ");
};
var msToSecs = function(ms) {
    return ms / 1000;
};
var secsToMs = function(secs) {
    return secs * 1000;
};
var padZeroesToNumber = function(number, digits) {
    return number.toString().padStart(digits, "0");
};
var rangeMap = function(input, inputStart, inputEnd, outputStart, outputEnd) {
    return (input - inputStart) / (inputEnd - inputStart) * (outputEnd - outputStart) + outputStart;
};
var userTagRegex = /(@\w+)/g;
var mdCodeRegex = /`(\w+)`/g;
var processString = function(options) {
    var key = 0;
    function processInputWithRegex(option, input) {
        if (!option.fn || typeof option.fn !== "function") return input;
        if (!option.regex || !(0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(option.regex, RegExp)) return input;
        if (typeof input === "string") {
            var regex = option.regex;
            var result = null;
            var output = [];
            while((result = regex.exec(input)) !== null){
                var index = result.index;
                var match = result[0];
                output.push(input.substring(0, index));
                output.push(option.fn(++key, result));
                input = input.substring(index + match.length, input.length + 1);
                regex.lastIndex = 0;
            }
            output.push(input);
            return output;
        } else if (Array.isArray(input)) {
            return input.map(function(chunk) {
                return processInputWithRegex(option, chunk);
            });
        } else return input;
    }
    return function processString(input) {
        if (!options || !Array.isArray(options) || !options.length) return input;
        options.forEach(function(option) {
            return input = processInputWithRegex(option, input);
        });
        return input;
    };
};


/***/ }),

/***/ 6102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X5": function() { return /* binding */ checkIsExternal; }
/* harmony export */ });
/* unused harmony exports cleanPath, getHrefWithQuery */
/* harmony import */ var _lib_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7469);

/**
 * Returns pathname without query params.
 */ var cleanPath = function(href) {
    var uri = new URL(href, siteOrigin);
    return uri.pathname;
};
/**
 * Checks is link is external or not.
 */ var checkIsExternal = function(href) {
    try {
        var url = new URL(href);
        var hostname = new URL(_lib_constants__WEBPACK_IMPORTED_MODULE_0__/* .siteOrigin */ .i0).hostname;
        if (url.hostname !== hostname) return true;
    } catch (error) {
        // failed cause href is relative
        return false;
    }
};
/**
 * Returns href with query parameters and hash. Handles overrides or deletions appropriately.
 */ var getHrefWithQuery = function(href, newQueryParams) {
    var override = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var uri = new URL(href, siteOrigin);
    if (newQueryParams) {
        Object.keys(newQueryParams).forEach(function(key) {
            var value = newQueryParams[key];
            if (value === null) {
                if (override) uri.searchParams.delete(key);
                return;
            }
            if (uri.searchParams.has(key) && override) {
                uri.searchParams.delete(key);
            }
            uri.searchParams.append(key, value);
        });
    }
    return "".concat(uri.pathname).concat(uri.search).concat(uri.hash);
};


/***/ }),

/***/ 1435:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"heading_heading__az_04","centered":"heading_centered__FgZep","sm":"heading_sm__PkYTD","lg":"heading_lg__I_Urf"};

/***/ }),

/***/ 5644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"progress-bar":"progress-bar_progress-bar__EPU0M","vertical":"progress-bar_vertical__mCE_a","progress":"progress-bar_progress__PPk6I","solid":"progress-bar_solid__HZBMx","horizontal":"progress-bar_horizontal__ZsMbl","marker":"progress-bar_marker__AF5nQ","progress-gradient":"progress-bar_progress-gradient__HyrJH","active":"progress-bar_active__p4Pe0","marker-thumb":"progress-bar_marker-thumb___Fjbc","radar":"progress-bar_radar__PdB1d"};

/***/ }),

/***/ 2676:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__0dtL1","section-heading":"section_section-heading__TZKTe","subtitle":"section_subtitle__LXO0V","centered":"section_centered__n_EqH"};

/***/ }),

/***/ 199:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"announcement":"announcement-bar_announcement__ilP9l","text":"announcement-bar_text__2E3ul"};

/***/ }),

/***/ 689:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"footer_section__2JmBF","overflowed":"footer_overflowed__PXTe6","bg":"footer_bg__VIRzp","hidden":"footer_hidden__7Gmu_","footer":"footer_footer___e0bO","top":"footer_top__kvW_P","head":"footer_head__dpu0X","heading":"footer_heading__64ZQk","logo":"footer_logo__H37xW","iso":"footer_iso__NQlqf","cta":"footer_cta__zB_y3","play-button":"footer_play-button__Pz3b_","timeline":"footer_timeline__HWaFq","middle":"footer_middle__yS5YW","get-in-touch":"footer_get-in-touch__uxmWt","title":"footer_title__tzKMw","email":"footer_email__w3ulM","nav":"footer_nav__Wxyub","nav-group":"footer_nav-group__7jHfa","list":"footer_list__4Dy1L","bottom":"footer_bottom__C_rhG","rights":"footer_rights__5_dWU","social":"footer_social__77ksZ"};

/***/ }),

/***/ 5851:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__zXy1G","has-scrolled":"header_has-scrolled__7er7x","inner-mobile":"header_inner-mobile__pTcjW","mobile-wrapper":"header_mobile-wrapper__fgHzw","burger":"header_burger__H1VG8","menu":"header_menu__aJhiu","menu-inner":"header_menu-inner__zV_GW","nav-link":"header_nav-link__prW1g","active":"header_active__A3R_B","icon":"header_icon___j9Wg","inner-desktop":"header_inner-desktop__H5N29","nav":"header_nav__GWdzn"};

/***/ }),

/***/ 555:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button___eDCW","unstyled":"button_unstyled__ySA8g","rounded":"button_rounded__6Lx2Y","no-hover":"button_no-hover__4NbyZ","content":"button_content__Vr3vS","md":"button_md____TNT","sm":"button_sm__OIlu8","primary":"button_primary__AlPPO","secondary":"button_secondary__iu_7q","tertiary":"button_tertiary__aSJSu","tertiary-inverted":"button_tertiary-inverted__O8izc","tertiary-inverted-alt":"button_tertiary-inverted-alt__DdhdD"};

/***/ }),

/***/ 3682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__3CZgY"};

/***/ }),

/***/ 9451:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);